export default "__VITE_ASSET__DFMRyiXO__"